(function() { window.GUID_a9bf7239_f6b1_4f1a_b552_df332f14911d = { getGuid: function() { return "a9bf7239-f6b1-4f1a-b552-df332f14911d"; } }; })();
var CS;
(function (CS) {
    function Instantiate(jsonData) {
        if (!CS.CommonData.Current) {
            new CS.CommonData();
        }
        CS.CommonData.Current.Refresh(jsonData);
    }
    CS.Instantiate = Instantiate;
    class CommonData {
        get BrowserSupportsCanvasAPIFilterProperty() {
            return (typeof CanvasRenderingContext2D !== "undefined" &&
                CanvasRenderingContext2D.prototype.hasOwnProperty("filter"));
        }
        get UserIsLoggedIn() {
            return this.UserId > 0;
        }
        get IsMobileDevice() {
            return /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|ca.compusport.compusport/i.test(navigator.userAgent);
        }
        get IsTouchScreenDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0;
        }
        get IsLandscapeOrientation() {
            return window.innerWidth > window.innerHeight;
        }
        constructor() {
            CS.CommonData.Current = this;
        }
        RefreshFromSmartResponse(data) {
            if (data) {
                this.UserId = data.UserId;
                this.UserDeviceId = data.UserDeviceId;
                this.UserHash = data.UserHash;
                this.BrowserHasAnimationBug = data.BrowserHasAnimationBug;
                this.FavoritesCount = data.FavoritesCount;
                this.PinsCount = data.PinsCount;
                this.Language = data.Language;
                this.IsNativeApp = data.IsNativeApp;
                this.IsOldNativeApp = data.IsOldNativeApp;
                this.DebugConfig = data.DebugConfig;
                this.Navigation = data.Navigation;
                this.Highlighteds = data.Highlighted;
                this.IsPremiumEssential = data.IsPremiumEssential;
                this.IsPremium = data.IsPremium;
                this.IsPremiumTempUnlocked = data.IsPremiumTempUnlocked;
                this.IsFunctionalAppPreferenceAccepted = data.IsFunctionalAppPreferenceAccepted;
                this.IsAnalyticsAppAccepted = data.IsAnalyticsAppAccepted;
                this.IsMarketingGoogleAccepted = data.IsMarketingGoogleAccepted;
                this.IsAnalyticsMetaAccepted = data.IsAnalyticsMetaAccepted;
                this.IsFunctionalYoutubeAccepted = data.IsFunctionalYoutubeAccepted;
                this.Latitude = data.Latitude;
                this.Longitude = data.Longitude;
                this.CoordAccuracy = data.CoodAccuracy;
                this.AdsEnabled = data.AdsEnabled;
                moment.locale(this.Language); //This set language to momentJs globally
            }
        }
        Refresh(jsonData) {
            let data = JSON.parse(jsonData);
            this.RefreshFromSmartResponse(data);
        }
        IsDebug() {
            var _a;
            if (!this.DebugConfig) {
                return false;
            }
            return ((_a = this.DebugConfig) === null || _a === void 0 ? void 0 : _a.toLowerCase()) != "release";
        }
    }
    CS.CommonData = CommonData;
})(CS || (CS = {}));

//# sourceMappingURL=cs-commondata.js.map
